import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class ExpMinWasSetForEachStackItemValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {legacyControlledHitterStacking} = this.dependencies;

        const firstGroupItems = legacyControlledHitterStacking.getFirstGroupItems();

        this.validateExpMinInItems(firstGroupItems);

        if (this.hasErrors() || !legacyControlledHitterStacking.isDoubleStackModeEnabled()) {
            return;
        }

        const secondGroupItems = legacyControlledHitterStacking.getSecondGroupItems();

        this.validateExpMinInItems(secondGroupItems);
    }

    private validateExpMinInItems(items): void {
        for (let item of items) {
            if (!item.expMin || Const.LEGACY_CONTROLLED_STACKING_EXP_MIN_PERCENT > item.expMin) {
                this.addError('An exposure in the hitter stack has to be specified, please check.');
                break;
            }
        }
    }
}

export default ExpMinWasSetForEachStackItemValidator;
